/** @module root/components/policies/settings */

import { IDS } from './pnp-docs.constants';
import * as STATES from './pnp-docs.states';
import * as STATES_DOCUMENT from './pnp-doc/pnp-doc.states';
import * as STATES_APPROVAL from './pnp-approval/pnp-approval.states';

import { pnpDocumentDetails } from './pnp-doc/details/pnp-doc-details.component';
import { pnpDocumentGrid } from './pnp-doc/grid/pnp-doc-grid.component';
import { pnpApprovalGrid } from './pnp-approval/grid/pnp-approval-grid.component';
import { pnpDocument } from './pnp-doc/pnp-doc.component';
import { pnpApprovalDetails } from './pnp-approval/details/pnp-approval-details.component';
import { pnpApproval } from './pnp-approval/pnp-approval.component';
import { pnpDocumentHistoryGrid } from './pnp-doc/history/pnp-doc-history-grid.component';
import { pnpDocumentHistory } from './pnp-doc/history/pnp-doc-history.component';
import { pnpDocHistoryDetails } from './pnp-doc/history/details/pnp-doc-history-details.component';
import { pnpDocumentAccreditationGrid } from './pnp-doc/accreditation/grid/pnp-doc-accreditation-grid.component';
import { pnpDocumentAccreditation } from './pnp-doc/accreditation/pnp-doc-accreditation.component';
import { pnpDocumentAccreditationDetails } from './pnp-doc/accreditation/details/pnp-doc-accreditation-details.component';
import { pnpDocumentEventActions } from './pnp-doc/event-actions/pnp-doc-event-actions.component';
import { pnpDocumentEventActionsGrid } from './pnp-doc/event-actions/grid/pnp-doc-event-actions-grid.component';
import { pnpDocSectionsGrid } from './pnp-doc/accreditation/details/pnp-doc-sections-grid.component';

export const PNP_DOCUMENTS_MODULE = angular.module(
    'migration.pnp.documents',
    []
).config(['$uiRouterProvider', ({ stateRegistry }) => {
    Object.values({ ...STATES, ...STATES_DOCUMENT, ...STATES_APPROVAL }).map(
        state => stateRegistry.register(state)
    );
}]).component({
    pnpDocumentDetails,
    pnpDocumentGrid,
    pnpDocument,
    pnpDocHistoryDetails,
    pnpDocumentHistoryGrid,
    pnpDocumentHistory,
    pnpApprovalDetails,
    pnpApprovalGrid,
    pnpApproval,
    pnpDocumentAccreditationDetails,
    pnpDocumentAccreditationGrid,
    pnpDocumentAccreditation,
    pnpDocSectionsGrid,
    pnpDocumentEventActions,
    pnpDocumentEventActionsGrid,
}).run(['$templateCache', ({ put }) => {
    put('app.policies.documents.add.details', '<pnp-document-details></pnp-document-details>');
    put('app.policies.documents.manage.listing', '<pnp-document></pnp-document>');
    put('app.policies.documents.manage.details', '<pnp-document-details></pnp-document-details>');
    put('app.policies.documents.manage.history.listing', '<pnp-document-history></pnp-document-history>');
    put('app.policies.documents.manage.history.details', '<pnp-doc-history-details></pnp-doc-history-details>');
    put('./pnp-document-grid-filter.html', require('./pnp-doc/grid/pnp-document-grid-filter.html'));
    put('app.policies.documents.approval.listing', '<pnp-approval></pnp-approval>');
    put('app.policies.documents.approval.details', '<pnp-approval-details></pnp-approval-details>');
    put('./pnp-approval-grid-filter.html', require('./pnp-approval/grid/pnp-approval-grid-filter.html'));
    put('app.policies.documents.accreditation.add.details', '<pnp-document-accreditation-details></pnp-document-accreditation-details>');
    put('./pnp-document-accreditation-grid-filter.html', require('./pnp-doc/accreditation/grid/pnp-document-accreditation-grid-filter.html'));
    put('app.policies.documents.accreditation.manage.listing', '<pnp-document-accreditation></pnp-document-accreditation>');
    put('app.policies.documents.manage.eventActions.listing', '<pnp-document-event-actions></pnp-document-event-actions>');
}]);
